import { Component } from '@angular/core';
import { TranslateDirective } from '../shared/translate.directive';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorComponent } from '../shared/error/error.component';

@Component({
  selector: 'app-register-password',
  standalone: true,
  imports: [TranslateDirective, CommonModule, FormsModule, ErrorComponent],
  templateUrl: './register-password.component.html',
  styleUrl: './register-password.component.less'
})
export class RegisterPasswordComponent {
  registerPassModel:any={
    Email: "",
    Code: ""
  }
  success:any;
  hasErrors=false;
  errors:any;
  constructor(private service: LoginService, private router: Router){}

  ngOnInit(){}

  registerPassword(){
    this.success = false;
    this.hasErrors = false;
    this.errors = null;

    this.registerPassModel.Code = this.registerPassModel?.Code?.trim();
    this.service.registerPassword(this.registerPassModel).subscribe({
      next: res=>{
        if(res){
          this.success=true;
          this.errors = null;
        }
      },
      error: err=>{     
        this.hasErrors=true;
        this.errors=err?.error?.errors || err?.error || err;
      }
    })

  }

  redirect(){
    this.router.navigate(['/login']);
  }
}
